import { useEffect, useState } from "react";
import { ERROR_CODE } from "../../../app/constants";
import { ERROR_STRING, VALIDATION_ERROR } from "../../../app/errors";
import { ErrorWithString } from "../../../components/RegularComponents";

const TrustAccountSigningOfficer = (props) => {
  const {
    name,
    index,
    onSaveItem,
    validationError,
  } = props;

  const [officerName, setOfficerName] = useState(name);
  const [officierNameError, setOfficierNameError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [showValidationError, setShowValidationError] = useState(validationError);

  useEffect(() => {
    const validateOfficierName = () => {
      if (!officerName) {
        setOfficierNameError(VALIDATION_ERROR.EMPTY);
      } else {
        setOfficierNameError(VALIDATION_ERROR.NO_ERROR);
      }
    };

    if (showValidationError) {
      validateOfficierName();
    }
  }, [
    officerName,
    officierNameError,
    showValidationError,
  ]);

  return (
    <>
      <div className="row">
        <div className="col-lg-8">
          <div
            className={
              "ns-fieldset" +
              ((officierNameError !== ERROR_CODE.NO_ERROR) ? " has-error ns-fieldset-message-error" : "")
            }
          >
          <fieldset className="ns-fieldset">
            {officierNameError !== VALIDATION_ERROR.NO_ERROR && (
              <span
                id={"upload-work-history-duration-error"}
                className="ns-error-message field-validation-error"
              >
                {ErrorWithString(ERROR_STRING.CONTACT_DETAILS_NAME_EMPTY)}
              </span>
            )}
            <input
              type="text"
              className={
                "fw-25" +
                (officierNameError === VALIDATION_ERROR.NO_ERROR
                  ? " ns-input"
                  : " ns-input--error")
              }
              id={"upload-work-history-duration-text"}
              name={"upload-work-history-duration-text"}
              value={officerName}
              onChange={(e) => {
                setOfficerName(e.target.value);
              }}
              onBlur={() => {
                setShowValidationError(true);
                onSaveItem(index, officerName);
              }}
            />
          </fieldset>
          </div>
        </div>
      </div>
  
    </>
  );
};

export default TrustAccountSigningOfficer;
